module.exports = __webpack_public_path__ + "static/media/conn_point_production_comparative_per_month.57bca933.svg";